import LegalLayout, { LP, LL, LMail } from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "1. What are cookies?",
    body: (
      <LP>
        Cookies are small text files stored on your device when you visit a website. They are widely
        used to make websites work, keep them secure and remember basic preferences.
      </LP>
    ),
  },
  {
    heading: "2. What this website uses",
    body: (
      <>
        <LP>
          The 4EMPIRE website does <strong className="text-white">not</strong> use advertising,
          tracking or analytics cookies.
        </LP>
        <LP>
          Only technical storage strictly necessary for the operation and security of the website
          and its hosting infrastructure may be used (for example load balancing or security
          tokens). These do not require your consent as the site cannot function without them.
        </LP>
      </>
    ),
  },
  {
    heading: "3. Third-party services",
    body: (
      <>
        <LP>
          This website loads fonts from Google Fonts; when serving these files, Google may process
          technical data such as your IP address, under its own privacy policy.
        </LP>
        <LP>
          Links to WhatsApp and to our social networks open third-party services (Meta, LinkedIn,
          TikTok) which may set their own cookies once you leave our website. These services apply
          their own cookie and privacy policies.
        </LP>
      </>
    ),
  },
  {
    heading: "4. Managing cookies",
    body: (
      <>
        <LP>
          You can configure your browser at any time to refuse or delete cookies. Each browser has
          its own procedure, available in its settings or help menu (Chrome, Firefox, Safari, Edge).
        </LP>
        <LP>
          Please note that blocking strictly necessary technical cookies may prevent parts of this
          website from working properly.
        </LP>
      </>
    ),
  },
  {
    heading: "5. Updates & contact",
    body: (
      <LP>
        This cookie policy may be updated if the website's use of cookies changes. For any question,
        contact us at <LMail />.
      </LP>
    ),
  },
];

export default function Cookies() {
  return (
    <LegalLayout
      testid="cookies"
      title="Cookie"
      accent="Policy."
      description="Last updated: October 2026. How the 4EMPIRE website uses (and doesn't use) cookies."
      sections={SECTIONS}
    />
  );
}
